import Typography from '@mui/material/Typography';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => theme.spacing(3)};

  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: ${({ theme }) => theme.spacing(2)};
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const RowLabel = styled(Typography)`
  flex-shrink: 0;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const RowValue = styled(Typography)`
  min-width: 0;

  overflow-wrap: anywhere;
  text-align: right;
  color: ${({ theme }) => theme.palette.text.primary};

  user-select: text;
  -ms-user-select: text;
  -moz-user-select: text;
  -webkit-user-select: text;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(2)};

  margin-top: ${({ theme }) => theme.spacing(1)};
`;
